import { z } from 'zod';

export const PcpPatientServiceSchema = z.object({
  service: z.object({
    id: z.string().min(1),
    name: z.string().min(1),
    healee_ref: z.string().min(1),
  }),

  concerns: z.array(z.string().min(1)).optional(),
});

export type PcpPatientService = z.infer<typeof PcpPatientServiceSchema>;
